module.exports = __webpack_public_path__ + "img/13.05862a3f.jpg";